import { useAppDispatch, useAppSelector } from '../store/hooks'
import { setNameFilter } from '../store/appsSlice'
import './NameFilter.css'

function NameFilter() {
  const dispatch = useAppDispatch()
  const nameFilter = useAppSelector((state) => state.apps.nameFilter)

  return (
    <div className="name-filter" data-testid="name-filter">
      <input
        type="text"
        className="name-filter__input"
        data-testid="name-filter-input"
        placeholder="Filter by app name..."
        aria-label="Filter by app name"
        value={nameFilter}
        onChange={(e) => dispatch(setNameFilter(e.target.value))}
      />
    </div>
  )
}

export default NameFilter
